import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import ExploreScreen from '../screens/Explore/ExploreScreen';
import CategoryScreen from '../screens/Explore/CategoryScreen';
import BookDetailScreen from '../screens/Book/BookDetailScreen';
import InsightDetailScreen from '../screens/Book/InsightDetailScreen';
import CollectionDetailScreen from '../screens/Collection/CollectionDetailScreen';
import GuruDetailScreen from '../screens/shared/components/GuruDetailScreen';

export type ExploreStackParamList = {
  ExploreHome: undefined;
  Category: {
    categoryId: string;
    categoryName: string;
  };
  BookDetail: {
    bookId: string;
    languageCode?: string;
  };
  InsightDetail: {
    insights: any[];
    book?: any;
    bookTitle?: string;
    bookCoverUrl?: string;
    currentIndex: number;
    isMixedInsights?: boolean;
    fromRoute?: string;
  };
  CollectionDetail: {
    collectionId: string;
    collectionTitle: string;
    collectionIcon?: string;
    bookIds: string[];
  };
  GuruDetail: {
    guruId: string;
    guruName: string;
    guruImage: any;
    bookIds: string[];
  };
};

const Stack = createStackNavigator<ExploreStackParamList>();

const ExploreStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="ExploreHome" 
        component={ExploreScreen}
      />
      <Stack.Screen 
        name="Category" 
        component={CategoryScreen}
      />
      <Stack.Screen 
        name="BookDetail" 
        component={BookDetailScreen}
      />
      <Stack.Screen 
        name="InsightDetail" 
        component={InsightDetailScreen}
        options={{ 
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
        }} 
      />
      <Stack.Screen 
        name="CollectionDetail" 
        component={CollectionDetailScreen}
        options={{ 
          headerShown: false,
        }} 
      />
      <Stack.Screen 
        name="GuruDetail" 
        component={GuruDetailScreen}
        options={{ 
          headerShown: false,
        }} 
      />
    </Stack.Navigator>
  );
};

export default ExploreStackNavigator;

